import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { regeneratePassword } from '../../store/slices/authSlice';
import { toast } from 'react-toastify';

const RestorePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isRoot } = useSelector((state) => state.auth);
  const [otherError, setOtherError] = useState(null);
  const [formData, setFormData] = useState({
    email: '',
  });
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    email: false,
  }); 
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      if (isRoot) navigate("/admin/dashboard/invitations")
      else navigate("/admin/dashboard/moderator");
    }
  }, [navigate]);


  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
    if (validationErrors[id]) {
      setValidationErrors(prev => ({
        ...prev,
        [id]: false
      }));
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleResetPassword();
    }
  };

  const validateForm = () => {
    const errors = {
      email: !formData.email,
    };
    setValidationErrors(errors);
    return !errors.email;
  };

  const handleResetPassword = async () => {
    if (!validateForm()) {
      toast.error('Email is Required.', {
        position: 'top-right',
      });
      return;
    }

    setLoading(true);
    setSuccessMessage(''); // Reset success message
    try {
      const response = await dispatch(regeneratePassword(formData)).unwrap();
      
      // Show success message
      setSuccessMessage('Please check your mailbox for further instructions');
      toast.success('Password reset instructions sent to your email', {
        position: 'top-right',
      });
      
    } catch (error) {
      console.error('Password reset request failed:', error);
      toast.error(error || 'Password reset request failed. Please try again.', {
        position: 'top-right',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginBox">
      <div className="container d-flex justify-content-center align-items-center min-vh-100">
        <div className="col-md-6 col-lg-6">
          <div className="HeadingText text-center mb-4">
            <p className="h3">Admin Panel</p>
          </div>

          <div className="card">
            <div className="card-body px-4 py-5">
              <div className="cardText text-center mb-4">
                <p className="heading h4">Get New Password</p>
              </div>

              {successMessage && (
                <div className="alert alert-success text-center" role="alert">
                  {successMessage}
                </div>
              )}

              <div className="FormDiv">
                <div className="mb-3">
                  <input
                    type="email"
                    placeholder="Email"
                    className={`form-control ${validationErrors.email ? 'is-invalid' : ''}`}
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                    disabled={loading}
                  />
                  {validationErrors.email && (
                    <div className="invalid-feedback">Please enter your email</div>
                  )}
                </div>
                <div className="btnDiv text-center">
                  <button
                    className="default-btn btn btn-primary w-100 py-2"
                    onClick={handleResetPassword}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        Requesting...
                      </>
                    ) : (
                      'Request Password'
                    )}
                  </button>
                </div>
              </div>

              <div className="mt-5 text-center">
                <div className="mt-3">
                  <Link to="/auth/login">Login</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestorePassword;